import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Icon } from 'packages/eid-icons'
import { Tooltip } from 'packages/eid-ui'

const ClearButton = ({ setSelectedTreeValue }) => {
    const { t } = useTranslation()
    const theme = useTheme()

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '1rem',
            }}
        >
            <Tooltip title={t('Clear')}>
                <Box
                    onClick={() => setSelectedTreeValue(null)}
                    className="clear-button"
                    sx={{
                        background: '#fff !important',
                        borderRadius: '.5rem',
                        padding: '.4rem .6rem',
                        border: 'solid 1px #ebebed',
                        minWidth: 'auto',
                        cursor: 'pointer',
                        maxWidth: 'fit-content',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.5rem',
                        '&:hover': {
                            '& p': {
                                color: theme.palette.primary.main,
                            },
                            '& svg': {
                                color: theme.palette.primary.main,
                            },
                        },
                    }}
                >
                    <Typography
                        sx={{
                            cursor: 'pointer',
                            color: '#282828',
                            fontSize: '1.4rem',
                        }}
                    >
                        {t('Clear')}
                    </Typography>
                    <Icon name="Close" />
                </Box>
            </Tooltip>
        </Box>
    )
}

export default ClearButton
